// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import {
//   getDrivers,
//   getDriverById,
//   updateDriver,
//   getPendingDrivers,
//   approvePendingDriver,
//   rejectPendingDriver,
//   getPendingDriverById,
//   updatePendingDriver
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Mobile</th>
//           <th>License</th>
//           <th>Experience</th>
//           <th>Bus Owner</th>
//           <th>Assigned Bus</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-profile-image"></div>
//         {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const DriverManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [isEditingPending, setIsEditingPending] = useState(false);

//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const [viewMode, setViewMode] = useState('regular');
//   const [pendingDrivers, setPendingDrivers] = useState([]);
//   const [loadingPending, setLoadingPending] = useState(false);

//   const [editingDriver, setEditingDriver] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingDriver, setViewingDriver] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalDrivers, setTotalDrivers] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const fetchDrivers = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getDrivers(token, currentPage, pageSize, searchTerm);

//       if (response && response.drivers) {
//         const transformedDrivers = response.drivers.map((driver, index) => ({
//           id: driver._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: driver.profileImage,
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           assignedBus: driver.assignedBus || null,
//           busOwner: driver.busOwner || null,
//           isActive: driver.isActive || false,
//           joined: new Date(driver.createdAt).toISOString().split('T')[0],
//           status: driver.isActive ? 'Active' : 'Inactive',
//           isPending: false,
//           source: 'regular'
//         }));

//         setDrivers(transformedDrivers);
//         setTotalPages(response.totalPages || 1);
//         setTotalDrivers(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch drivers.');
//       console.error('Error fetching drivers:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const fetchPendingDrivers = async () => {
//     try {
//       setLoadingPending(true);
//       setError(null);

//       const response = await getPendingDrivers(token);

//       if (response && response.success) {
//         const transformedDrivers = response.data.map((driver, index) => ({
//           id: driver._id,
//           pendingId: driver._id,
//           serialNo: index + 1,
//           profileImage: driver.profileImage || '',
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           assignedBus: driver.assignedBus || null,
//           busOwner: driver.busOwner || null,
//           isActive: false,
//           joined: new Date(driver.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           isPending: true,
//           source: 'pending',
//           submittedBy: driver.submittedBy,
//           submittedByName: driver.submittedByName,
//           submittedByEmail: driver.submittedByEmail,
//           operationType: driver.operationType,
//           approvalStatus: driver.approvalStatus,
//           originalData: driver.originalData
//         }));

//         setPendingDrivers(transformedDrivers);
//         setTotalDrivers(transformedDrivers.length);
//         setTotalPages(1);
//       } else {
//         setPendingDrivers([]);
//         setTotalDrivers(0);
//         setTotalPages(1);
//       }
//     } catch (err) {
//       console.error('Error fetching pending drivers:', err);
//       setError('Failed to fetch pending drivers. Please try again.');
//       setPendingDrivers([]);
//     } finally {
//       setLoadingPending(false);
//     }
//   };

//   useEffect(() => {
//     if (viewMode === 'regular') {
//       fetchDrivers();
//     } else {
//       fetchPendingDrivers();
//     }
//   }, [viewMode, currentPage, searchTerm]);

//   const refreshPendingDrivers = async () => {
//     await fetchPendingDrivers();
//   };

//   const getCurrentDrivers = () => {
//     return viewMode === 'regular' ? drivers : pendingDrivers;
//   };

//   const getCurrentLoading = () => {
//     return viewMode === 'regular' ? loading : loadingPending;
//   };

//   const currentDrivers = getCurrentDrivers();
//   const isLoading = getCurrentLoading();

//   const handleApprovePendingDriver = async (pendingId) => {
//     try {
//       setError(null);
//       const response = await approvePendingDriver(pendingId, token);

//       if (response.success) {
//         toast.success('Pending driver approved successfully!');
//         setPendingDrivers(prev => prev.filter(driver => driver.id !== pendingId));
//         setTotalDrivers(prev => prev - 1);
//         await fetchDrivers();
//       } else {
//         throw new Error(response.message || 'Failed to approve pending driver');
//       }
//     } catch (err) {
//       console.error('Error approving pending driver:', err);
//       setError('Failed to approve pending driver. Please try again.');
//       toast.error('Failed to approve pending driver. Please try again.');
//     }
//   };

//   const handleRejectPendingDriver = async (pendingId) => {
//     if (!window.confirm('Are you sure you want to reject this pending driver?')) return;

//     try {
//       setError(null);
//       const response = await rejectPendingDriver(pendingId, token);

//       if (response.success) {
//         toast.success('Pending driver rejected successfully!');
//         setPendingDrivers(prev => prev.filter(driver => driver.id !== pendingId));
//         setTotalDrivers(prev => prev - 1);
//       } else {
//         throw new Error(response.message || 'Failed to reject pending driver');
//       }
//     } catch (err) {
//       console.error('Error rejecting pending driver:', err);
//       setError('Failed to reject pending driver. Please try again.');
//       toast.error('Failed to reject pending driver. Please try again.');
//     }
//   };

//   const handleViewDriver = async (driver) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);

//       let response;

//       if (driver.isPending) {
//         response = await getPendingDriverById(driver.id, token);
//       } else {
//         response = await getDriverById(driver.id, token);
//       }

//       if (response.success) {
//         const driverData = response.data;
//         setViewingDriver({
//           id: driverData._id,
//           name: driverData.name || '',
//           mobileNumber: driverData.mobileNumber || '',
//           licenseNumber: driverData.licenseNumber || '',
//           experience: driverData.experience || 0,
//           email: driverData.email || '',
//           address: driverData.address || '',
//           isActive: driverData.isActive,
//           assignedBus: driverData.assignedBus || null,
//           busOwner: driverData.busOwner || null,
//           profileImage: driverData.profileImage,
//           createdAt: new Date(driverData.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(driverData.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           isPending: driver.isPending,
//           submittedBy: driverData.submittedBy,
//           submittedByName: driverData.submittedByName,
//           operationType: driverData.operationType
//         });
//       } else {
//         setError('Failed to fetch driver details.');
//       }
//     } catch (err) {
//       console.error('Error fetching driver details:', err);
//       setError('Failed to fetch driver details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditDriver = async (driverId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);

//       const response = await getDriverById(driverId, token);

//       if (response.success) {
//         const driver = response.data;
//         setEditingDriver(driver._id);
//         setEditForm({
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           isActive: driver.isActive || true
//         });
//       } else {
//         setError('Failed to fetch driver details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching driver details for editing:', err);
//       setError('Failed to fetch driver details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditPendingDriver = async (driverId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
//       setIsEditingPending(true);

//       const response = await getPendingDriverById(driverId, token);

//       if (response.success) {
//         const driver = response.data;
//         setEditingDriver(driver._id);
//         setEditForm({
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           isActive: false
//         });
//       } else {
//         setError('Failed to fetch pending driver details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching pending driver details for editing:', err);
//       setError('Failed to fetch pending driver details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       const updateData = {
//         name: editForm.name,
//         mobileNumber: editForm.mobileNumber,
//         licenseNumber: editForm.licenseNumber,
//         experience: editForm.experience,
//         ...(isEditingPending ? {} : { isActive: editForm.isActive })
//       };

//       const response = isEditingPending
//         ? await updatePendingDriver(editingDriver, updateData, token)
//         : await updateDriver(editingDriver, updateData, token);

//       if (response.success) {
//         if (isEditingPending) {
//           setPendingDrivers(prevDrivers =>
//             prevDrivers.map(driver =>
//               driver.id === editingDriver ? {
//                 ...driver,
//                 name: response.data.name,
//                 mobileNumber: response.data.mobileNumber,
//                 licenseNumber: response.data.licenseNumber,
//                 experience: response.data.experience,
//               } : driver
//             )
//           );
//           toast.success('Pending driver updated successfully!');
//         } else {
//           setDrivers(prevDrivers =>
//             prevDrivers.map(driver =>
//               driver.id === editingDriver ? {
//                 ...driver,
//                 name: response.data.name,
//                 mobileNumber: response.data.mobileNumber,
//                 licenseNumber: response.data.licenseNumber,
//                 experience: response.data.experience,
//                 status: response.data.isActive ? 'Active' : 'Inactive',
//                 isActive: response.data.isActive
//               } : driver
//             )
//           );
//           alert('Driver updated successfully!');
//         }

//         setEditingDriver(null);
//         setEditForm({});
//         setIsEditingPending(false);
//       } else {
//         setError(response.message || 'Failed to update driver.');
//       }
//     } catch (err) {
//       console.error('Error updating driver:', err);
//       setError(err.response?.data?.message || 'Failed to update driver. Please try again.');
//       if (!isEditingPending) alert('Failed to update driver. Please try again.');
//       else toast.error('Failed to update pending driver. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingDriver(null);
//     setEditForm({});
//     setError(null);
//     setIsEditingPending(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingDriver(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     if (viewMode === 'regular') {
//       fetchDrivers();
//     } else {
//       fetchPendingDrivers();
//     }
//   };

//   const handleExportCSV = () => {
//     if (currentDrivers.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'License', 'Experience', 'Bus Owner', 'Assigned Bus', 'Status'];
//     const csvData = currentDrivers.map(driver => [
//       driver.serialNo,
//       driver.id,
//       driver.name || '',
//       driver.mobileNumber || '',
//       driver.licenseNumber || '',
//       driver.experience || '',
//       driver.busOwner?.name || 'N/A',
//       driver.assignedBus?.busNumber || 'Not Assigned',
//       driver.status
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `drivers-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const filteredDrivers = currentDrivers.filter(driver =>
//     (driver.name && driver.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.mobileNumber && driver.mobileNumber.includes(searchTerm)) ||
//     (driver.licenseNumber && driver.licenseNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.busOwner?.name && driver.busOwner.name.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   if (isLoading) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Driver Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search drivers by name, mobile, license or bus owner..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>

//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         {viewMode === 'regular' ? (
//           <>Page: {currentPage} | Total Pages: {totalPages} | Total Drivers: {totalDrivers}</>
//         ) : (
//           <>Pending Drivers: {pendingDrivers.length} | {loadingPending ? 'Loading...' : ''}</>
//         )}
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total {viewMode === 'regular' ? 'Drivers' : 'Pending Drivers'}</h3>
//           <p>{totalDrivers}</p>
//           <span>{viewMode === 'regular' ? 'All registered drivers' : 'Awaiting approval'}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Drivers</h3>
//           <p>{viewMode === 'regular' ? drivers.filter(d => d.status === 'Active').length : 0}</p>
//           <span>Active drivers</span>
//         </div>
//         <div className="stat-card">
//           <h3>With Assigned Bus</h3>
//           <p>{viewMode === 'regular' ? drivers.filter(d => d.assignedBus).length : 0}</p>
//           <span>Drivers with bus assignment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{filteredDrivers.length}</p>
//           <span>drivers found</span>
//         </div>
//       </div>


//       <div className="view-toggle-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '0 15px' }}>
//         <button
//           className={`toggle-btn ${viewMode === 'regular' ? 'active' : ''}`}
//           onClick={() => {
//             setViewMode('regular');
//             setCurrentPage(1);
//             setSearchTerm('');
//           }}
//           style={{
//             padding: '8px 20px',
//             borderRadius: '20px',
//             border: '2px solid #007bff',
//             backgroundColor: viewMode === 'regular' ? '#007bff' : 'transparent',
//             color: viewMode === 'regular' ? 'white' : '#007bff',
//             cursor: 'pointer',
//             fontWeight: '500',
//             transition: 'all 0.3s'
//           }}
//         >
//           👤 Regular
//         </button>
//         <button
//           className={`toggle-btn ${viewMode === 'pending' ? 'active' : ''}`}
//           onClick={() => {
//             setViewMode('pending');
//             setCurrentPage(1);
//             setSearchTerm('');
//           }}
//           style={{
//             padding: '8px 20px',
//             borderRadius: '20px',
//             border: '2px solid #ff9800',
//             backgroundColor: viewMode === 'pending' ? '#ff9800' : 'transparent',
//             color: viewMode === 'pending' ? 'white' : '#ff9800',
//             cursor: 'pointer',
//             fontWeight: '500',
//             transition: 'all 0.3s',
//             position: 'relative'
//           }}
//         >
//           📋 Executive Submitted
//           {viewMode === 'pending' && pendingDrivers.length > 0 && (
//             <span style={{
//               position: 'absolute',
//               top: '-8px',
//               right: '-8px',
//               backgroundColor: 'red',
//               color: 'white',
//               borderRadius: '50%',
//               width: '20px',
//               height: '20px',
//               fontSize: '10px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold'
//             }}>
//               {pendingDrivers.length}
//             </span>
//           )}
//         </button>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Mobile</th>
//               <th>License</th>
//               <th>Experience</th>
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredDrivers.length > 0 ? (
//               filteredDrivers.map(driver => (
//                 <tr key={driver.id} className={driver.isPending ? 'pending-row' : ''}>
//                   <td>{driver.serialNo}</td>
//                   <td>
//                     {!driver.isPending && editingDriver === driver.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Name"
//                       />
//                     ) : (
//                       <>
//                         {driver.name || 'N/A'}

//                       </>
//                     )}
//                   </td>
//                   <td>
//                     {!driver.isPending && editingDriver === driver.id ? (
//                       <input
//                         type="text"
//                         name="mobileNumber"
//                         value={editForm.mobileNumber || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Mobile Number"
//                       />
//                     ) : (
//                       driver.mobileNumber || 'N/A'
//                     )}
//                   </td>
//                   <td>
//                     {!driver.isPending && editingDriver === driver.id ? (
//                       <input
//                         type="text"
//                         name="licenseNumber"
//                         value={editForm.licenseNumber || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="License Number"
//                       />
//                     ) : (
//                       driver.licenseNumber || 'N/A'
//                     )}
//                   </td>
//                   <td>
//                     {!driver.isPending && editingDriver === driver.id ? (
//                       <input
//                         type="number"
//                         name="experience"
//                         value={editForm.experience || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Years"
//                         min="0"
//                       />
//                     ) : (
//                       driver.experience ? `${driver.experience} years` : 'N/A'
//                     )}
//                   </td>
//                   <td>
//                     {driver.busOwner?.name || 'N/A'}
//                   </td>
//                   <td>
//                     {driver.assignedBus ? (
//                       <div className="bus-info">
//                         <div><strong>{driver.assignedBus.busNumber}</strong></div>
//                         <small>{driver.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </td>
//                   <td>
//                     {!driver.isPending && editingDriver === driver.id ? (
//                       <label className="checkbox-label">
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={editForm.isActive || false}
//                           onChange={handleInputChange}
//                         />
//                         <span className="checkbox-text">
//                           {editForm.isActive ? 'Active' : 'Inactive'}
//                         </span>
//                       </label>
//                     ) : (
//                       <span className={`status-badge ${driver.isPending ? 'pending' : driver.status?.toLowerCase() || 'inactive'}`}>
//                         {driver.isPending ? 'Pending Approval' : driver.status || 'Inactive'}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {!driver.isPending ? (
//                       editingDriver === driver.id ? (<div className="edit-actions">
//                         <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                           {isFetchingDetails ? 'Saving...' : 'Save'}
//                         </button>
//                         <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                           Cancel
//                         </button>
//                       </div>) : (<div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewDriver(driver)}
//                           disabled={isFetchingDetails}
//                         >
//                           {isFetchingDetails ? 'Loading...' : 'View'}
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditDriver(driver.id)}
//                           disabled={isFetchingDetails}
//                         >
//                           {isFetchingDetails ? 'Loading...' : 'Edit'}
//                         </button>
//                       </div>)
//                     ) : (
//                       <td>
//                         {!driver.isPending ? (
//                           editingDriver === driver.id ? (<div className="edit-actions">
//                             <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                               {isFetchingDetails ? 'Saving...' : 'Save'}
//                             </button>
//                             <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                               Cancel
//                             </button>
//                           </div>) : (<div className="action-buttons">
//                             <button className="action-btn view" onClick={() => handleViewDriver(driver)} style={{ backgroundColor: '#17a2b8' }}>
//                               View
//                             </button>
//                             <button className="action-btn edit" onClick={() => handleEditDriver(driver.id)} disabled={isFetchingDetails} style={{ backgroundColor: '#6f42c1', color: 'white' }}>
//                               {isFetchingDetails ? 'Loading...' : 'Edit'}
//                             </button>
//                           </div>)
//                         ) : (
//                           <div className="action-buttons">
//                             <button className="action-btn view" onClick={() => handleViewDriver(driver)} style={{ backgroundColor: '#17a2b8' }}>
//                               View
//                             </button>
//                             <button
//                               className="action-btn edit"
//                               onClick={() => handleEditPendingDriver(driver.id)}
//                               disabled={isFetchingDetails}
//                               style={{ backgroundColor: '#6f42c1', color: 'white' }}
//                             >
//                               {isFetchingDetails ? 'Loading...' : 'Edit'}
//                             </button>
//                             <button className="action-btn approve" onClick={() => handleApprovePendingDriver(driver.id)} style={{ backgroundColor: '#28a745' }}>
//                               Approve
//                             </button>
//                             <button className="action-btn reject" onClick={() => handleRejectPendingDriver(driver.id)} style={{ backgroundColor: '#dc3545' }}>
//                               Reject
//                             </button>
//                             {driver.submittedByName && (
//                               <div style={{
//                                 fontSize: '10px',
//                                 color: '#666',
//                                 marginTop: '4px',
//                                 display: 'block'
//                               }}>
//                                 By: {driver.submittedByName}
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </td>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>
//                     {viewMode === 'regular'
//                       ? `No drivers found ${searchTerm ? 'matching your search' : ''}.`
//                       : 'No pending drivers from executive submissions.'}
//                   </p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all drivers
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>


//       {viewMode === 'regular' && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {drivers.length} of {totalDrivers} drivers
//             (Page {currentPage} of {totalPages})
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}


//       {viewingDriver && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Driver Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={viewingDriver.profileImage ?
//                       `${process.env.REACT_APP_BASE_URL}/uploads/${viewingDriver.profileImage}` :
//                       ''}
//                     alt={viewingDriver.name || 'Driver'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = '';
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingDriver.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingDriver.mobileNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>License Number:</label>
//                   <span>{viewingDriver.licenseNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Experience:</label>
//                   <span>{viewingDriver.experience} years</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Bus Owner:</label>
//                   <span>
//                     {viewingDriver.busOwner ? (
//                       <div className="bus-owner-info">
//                         <strong>{viewingDriver.busOwner.name}</strong>
//                         <small>{viewingDriver.busOwner.phone}</small>
//                       </div>
//                     ) : 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Assigned Bus:</label>
//                   <span>
//                     {viewingDriver.assignedBus ? (
//                       <div className="bus-info">
//                         <strong>{viewingDriver.assignedBus.busNumber}</strong>
//                         <small>{viewingDriver.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingDriver.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingDriver.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingDriver.isActive ? 'active' : 'inactive'}`}>
//                     {viewingDriver.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingDriver && isFetchingDetails && <SkeletonModal />}


//       {editingDriver && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{isEditingPending ? 'Edit Pending Driver' : 'Edit Driver'}</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Driver Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Mobile Number:</label>
//                   <input
//                     type="text"
//                     name="mobileNumber"
//                     value={editForm.mobileNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Mobile Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>License Number:</label>
//                   <input
//                     type="text"
//                     name="licenseNumber"
//                     value={editForm.licenseNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="License Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Experience (years):</label>
//                   <input
//                     type="number"
//                     name="experience"
//                     value={editForm.experience || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Years of experience"
//                     min="0"
//                     step="0.5"
//                   />
//                 </div>
//                 {!isEditingPending && (
//                   <div className="form-group checkbox-group">
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">Active Driver</span>
//                     </label>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {editingDriver && isFetchingDetails && <SkeletonEditModal />}
//     </div>
//   );
// };

// export default DriverManagement;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/DriverManage.css';         // driver-only additions (load LAST)
import {
  getDrivers,
  getDriverById,
  updateDriver,
  getPendingDrivers,
  approvePendingDriver,
  rejectPendingDriver,
  getPendingDriverById,
  updatePendingDriver
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const imgUrl = (p) => (p ? `${process.env.REACT_APP_BASE_URL}/uploads/${p}` : '');

// ============================================================
// Driver card
// ============================================================
const DriverCard = ({ d, index, onView, onEdit, onApprove, onReject }) => (
  <div className={`prm-card dm-card ${d.isPending ? 'pending' : ''}`} style={{ animationDelay: `${index * 70}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={d.name} src={imgUrl(d.profileImage)} size={52} />
        <div>
          <div className="prm-card-no">Driver #{String(d.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{d.name || 'N/A'}</h3>
          <div className="prm-card-sub"><Icon name="calendar" size={14} /> Joined {d.joined}</div>
        </div>
      </div>
      <span className={`prm-status ${d.isPending ? 'pending' : d.isActive ? 'active' : 'inactive'}`}>
        {d.isPending ? 'Pending' : d.status}
      </span>
    </div>
    <div className="pbo-contact">
      <div><Icon name="phone" size={14} /> {d.mobileNumber || 'N/A'}</div>
      <div><Icon name="info" size={14} /> License: {d.licenseNumber || 'N/A'}</div>
    </div>
    <div className="prm-metrics">
      <div className="prm-metric"><div className="v"><Icon name="clock" size={15} /> {d.experience || 0}y</div><div className="l">Experience</div></div>
      <div className="prm-metric"><div className="v"><Icon name="bus" size={15} /> {d.assignedBus?.busNumber || '—'}</div><div className="l">Assigned Bus</div></div>
      <div className="prm-metric"><div className="v"><Icon name="users" size={15} /> {d.busOwner?.name || '—'}</div><div className="l">Bus Owner</div></div>
    </div>
    {d.isPending && d.submittedByName && (
      <div className="dm-submitted-by">Submitted by: {d.submittedByName}</div>
    )}
    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(d)}><Icon name="eye" size={14} /> View</button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(d)}><Icon name="edit" size={14} /> Edit</button>
      {d.isPending && (
        <>
          <button className="prm-btn primary sm" onClick={() => onApprove(d.id)}><Icon name="check" size={14} /> Approve</button>
          <button className="prm-btn danger sm" onClick={() => onReject(d.id)}><Icon name="x" size={14} /> Reject</button>
        </>
      )}
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const DriverManagement = () => {
  const { token } = useSelector(state => state.user);

  const [drivers, setDrivers] = useState([]);
  const [pendingDrivers, setPendingDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPending, setLoadingPending] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [layout, setLayout] = useState('table');
  const [viewMode, setViewMode] = useState('regular');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalDrivers, setTotalDrivers] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalDrivers / pageSize));

  const [viewingDriver, setViewingDriver] = useState(null);
  const [editingDriver, setEditingDriver] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [isEditingPending, setIsEditingPending] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // ---------- fetch regular drivers (debounced, server-side paging + search) ----------
  useEffect(() => {
    if (viewMode !== 'regular') return;
    const t = setTimeout(fetchDrivers, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm, viewMode]);

  // ---------- fetch pending drivers ----------
  useEffect(() => {
    if (viewMode !== 'pending') return;
    fetchPendingDrivers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode]);

  const fetchDrivers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getDrivers(token, currentPage, pageSize, searchTerm);
      if (response && response.drivers) {
        setDrivers(response.drivers.map((driver, index) => ({
          id: driver._id,
          serialNo: (currentPage - 1) * pageSize + index + 1,
          profileImage: driver.profileImage,
          name: driver.name || '',
          mobileNumber: driver.mobileNumber || '',
          licenseNumber: driver.licenseNumber || '',
          experience: driver.experience || 0,
          assignedBus: driver.assignedBus || null,
          busOwner: driver.busOwner || null,
          isActive: driver.isActive || false,
          joined: formatDateDMY(driver.createdAt),
          status: driver.isActive ? 'Active' : 'Inactive',
          isPending: false,
          source: 'regular'
        })));
        setTotalDrivers(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch drivers.');
      console.error('Error fetching drivers:', err);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  const fetchPendingDrivers = async () => {
    try {
      setLoadingPending(true);
      setError(null);
      const response = await getPendingDrivers(token);
      if (response && response.success) {
        setPendingDrivers(response.data.map((driver, index) => ({
          id: driver._id,
          pendingId: driver._id,
          serialNo: index + 1,
          profileImage: driver.profileImage || '',
          name: driver.name || '',
          mobileNumber: driver.mobileNumber || '',
          licenseNumber: driver.licenseNumber || '',
          experience: driver.experience || 0,
          assignedBus: driver.assignedBus || null,
          busOwner: driver.busOwner || null,
          isActive: false,
          joined: formatDateDMY(driver.createdAt),
          status: 'Pending',
          isPending: true,
          source: 'pending',
          submittedBy: driver.submittedBy,
          submittedByName: driver.submittedByName,
          submittedByEmail: driver.submittedByEmail,
          operationType: driver.operationType,
          approvalStatus: driver.approvalStatus,
          originalData: driver.originalData
        })));
        setTotalDrivers(response.data.length);
      } else {
        setPendingDrivers([]);
        setTotalDrivers(0);
      }
    } catch (err) {
      console.error('Error fetching pending drivers:', err);
      setError('Failed to fetch pending drivers. Please try again.');
      setPendingDrivers([]);
    } finally {
      setLoadingPending(false);
      setFirstLoad(false);
    }
  };

  // keep the page valid if the total shrinks
  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const currentDrivers = viewMode === 'regular' ? drivers : pendingDrivers;
  const isLoading = viewMode === 'regular' ? loading : loadingPending;

  const visible = useMemo(() => currentDrivers.filter(d =>
    statusFilter === 'all' ? true :
    statusFilter === 'active' ? d.status === 'Active' :
    statusFilter === 'pending' ? d.isPending :
    d.status !== 'Active'
  ), [currentDrivers, statusFilter]);

  const activeOnPage = currentDrivers.filter(d => d.status === 'Active').length;
  const assignedOnPage = currentDrivers.filter(d => d.assignedBus).length;

  // ---------- handlers ----------
  const handleExportCSV = () => {
    if (currentDrivers.length === 0) return toast.warning('No data to export');
    const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'License', 'Experience', 'Bus Owner', 'Assigned Bus', 'Status'];
    const rows = currentDrivers.map(d => [
      d.serialNo, d.id, d.name, d.mobileNumber, d.licenseNumber, d.experience,
      d.busOwner?.name || 'N/A', d.assignedBus?.busNumber || 'Not Assigned', d.status
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `drivers-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  const handleViewDriver = async (driver) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      const response = driver.isPending
        ? await getPendingDriverById(driver.id, token)
        : await getDriverById(driver.id, token);

      if (response.success) {
        const d = response.data;
        setViewingDriver({
          id: d._id,
          name: d.name || '',
          mobileNumber: d.mobileNumber || '',
          licenseNumber: d.licenseNumber || '',
          experience: d.experience || 0,
          email: d.email || '',
          address: d.address || '',
          isActive: d.isActive,
          assignedBus: d.assignedBus || null,
          busOwner: d.busOwner || null,
          profileImage: d.profileImage,
          joined: formatDateDMY(d.createdAt),
          updatedAt: formatDateDMY(d.updatedAt),
          isPending: driver.isPending,
          submittedBy: d.submittedBy,
          submittedByName: d.submittedByName,
          operationType: d.operationType
        });
      } else {
        setError('Failed to fetch driver details.');
      }
    } catch (err) {
      console.error('Error fetching driver details:', err);
      setError('Failed to fetch driver details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const openEdit = async (driver) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      setIsEditingPending(driver.isPending);

      const response = driver.isPending
        ? await getPendingDriverById(driver.id, token)
        : await getDriverById(driver.id, token);

      if (response.success) {
        const d = response.data;
        setEditingDriver(d._id);
        setEditForm({
          name: d.name || '',
          mobileNumber: d.mobileNumber || '',
          licenseNumber: d.licenseNumber || '',
          experience: d.experience || 0,
          isActive: d.isActive || false
        });
      } else {
        setError('Failed to fetch driver details for editing.');
      }
    } catch (err) {
      console.error('Error fetching driver details for editing:', err);
      setError('Failed to fetch driver details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    if (!editForm.name?.trim()) return toast.error('Name is required');
    try {
      setSaving(true);
      const updateData = {
        name: editForm.name,
        mobileNumber: editForm.mobileNumber,
        licenseNumber: editForm.licenseNumber,
        experience: editForm.experience,
        ...(isEditingPending ? {} : { isActive: editForm.isActive })
      };

      const response = isEditingPending
        ? await updatePendingDriver(editingDriver, updateData, token)
        : await updateDriver(editingDriver, updateData, token);

      if (response.success) {
        if (isEditingPending) {
          setPendingDrivers(prev => prev.map(d => d.id === editingDriver ? {
            ...d,
            name: response.data.name,
            mobileNumber: response.data.mobileNumber,
            licenseNumber: response.data.licenseNumber,
            experience: response.data.experience
          } : d));
        } else {
          setDrivers(prev => prev.map(d => d.id === editingDriver ? {
            ...d,
            name: response.data.name,
            mobileNumber: response.data.mobileNumber,
            licenseNumber: response.data.licenseNumber,
            experience: response.data.experience,
            status: response.data.isActive ? 'Active' : 'Inactive',
            isActive: response.data.isActive
          } : d));
        }
        toast.success(isEditingPending ? 'Pending driver updated successfully' : 'Driver updated successfully');
        setEditingDriver(null);
        setEditForm({});
        setIsEditingPending(false);
      } else {
        throw new Error(response.message || 'Failed to update driver');
      }
    } catch (err) {
      console.error('Error updating driver:', err);
      toast.error('Failed to update driver. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleApprovePendingDriver = async (pendingId) => {
    try {
      setError(null);
      const response = await approvePendingDriver(pendingId, token);
      if (response.success) {
        toast.success('Pending driver approved successfully!');
        setPendingDrivers(prev => prev.filter(d => d.id !== pendingId));
        setTotalDrivers(prev => prev - 1);
        await fetchDrivers();
      } else {
        throw new Error(response.message || 'Failed to approve pending driver');
      }
    } catch (err) {
      console.error('Error approving pending driver:', err);
      setError('Failed to approve pending driver. Please try again.');
      toast.error('Failed to approve pending driver. Please try again.');
    }
  };

  const handleRejectPendingDriver = async (pendingId) => {
    if (!window.confirm('Are you sure you want to reject this pending driver?')) return;
    try {
      setError(null);
      const response = await rejectPendingDriver(pendingId, token);
      if (response.success) {
        toast.success('Pending driver rejected successfully!');
        setPendingDrivers(prev => prev.filter(d => d.id !== pendingId));
        setTotalDrivers(prev => prev - 1);
      } else {
        throw new Error(response.message || 'Failed to reject pending driver');
      }
    } catch (err) {
      console.error('Error rejecting pending driver:', err);
      setError('Failed to reject pending driver. Please try again.');
      toast.error('Failed to reject pending driver. Please try again.');
    }
  };

  const handleRefresh = () => {
    setSearchTerm(''); setStatusFilter('all'); setCurrentPage(1);
    if (viewMode === 'regular') fetchDrivers();
    else fetchPendingDrivers();
  };

  // ============================================================
  if (firstLoad && isLoading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Drivers</span>
          <h1>Driver Management</h1><p>Loading drivers…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Driver Insights</span>
          <h1>Driver Management</h1>
          <p>Browse registered drivers, review their assignments and manage pending approvals.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by name, mobile, license or bus owner…" value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleExportCSV}>
            <span className="plus"><Icon name="download" size={14} /></span> Export CSV
          </button>
        </div>
      </div>

      {error && <div className="dm-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={handleRefresh}>Retry</button></div>}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="users" tone="indigo" label={viewMode === 'regular' ? 'Total Drivers' : 'Pending Drivers'} value={totalDrivers || currentDrivers.length} hint={viewMode === 'regular' ? 'All registered drivers' : 'Awaiting approval'} delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
        <StatCard icon="bus" tone="amber" label="With Assigned Bus" value={assignedOnPage} hint="Drivers with bus assignment" delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={currentDrivers.length} hint="Drivers on this page" delay={320} />
      </div>

      {/* TABS */}
      <div className="dm-tabs">
        <button className={`dm-tab ${viewMode === 'regular' ? 'active' : ''}`} onClick={() => { setViewMode('regular'); setCurrentPage(1); setSearchTerm(''); }}>
          <Icon name="users" size={15} /> Regular Drivers
        </button>
        <button className={`dm-tab ${viewMode === 'pending' ? 'active' : ''}`} onClick={() => { setViewMode('pending'); setCurrentPage(1); setSearchTerm(''); }}>
          <Icon name="clock" size={15} /> Executive Submitted
          {pendingDrivers.length > 0 && <span className="dm-badge">{pendingDrivers.length}</span>}
        </button>
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {[['all', 'All', currentDrivers.length], ['active', 'Active', activeOnPage], ['inactive', 'Inactive', currentDrivers.length - activeOnPage]].map(([k, l, c]) => (
              <button key={k} className={`prm-chip ${statusFilter === k ? 'active' : ''}`} onClick={() => setStatusFilter(k)}>
                {l} <span className="count">{c}</span>
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: "{searchTerm}"</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{visible.length}</b> of {totalDrivers}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={isLoading ? 'dm-loading' : ''}>
        {visible.length === 0 && !isLoading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'users'} size={44} /></div>
            <h3>{searchTerm || statusFilter !== 'all' ? 'No drivers match your search' : viewMode === 'pending' ? 'No pending drivers' : 'No drivers yet'}</h3>
            <p>{searchTerm || statusFilter !== 'all' ? 'Try a different search term or clear the filters.' : viewMode === 'pending' ? 'Executive-submitted drivers will appear here.' : 'Registered drivers will appear here.'}</p>
            {(searchTerm || statusFilter !== 'all') && <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {visible.map((d, i) => <DriverCard key={d.id} d={d} index={i} onView={handleViewDriver} onEdit={openEdit} onApprove={handleApprovePendingDriver} onReject={handleRejectPendingDriver} />)}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr><th>No.</th><th>Driver</th><th>Mobile</th><th>License</th><th>Experience</th><th>Bus Owner</th><th>Assigned Bus</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {visible.map((d, i) => (
                  <tr key={d.id} className={d.isPending ? 'dm-pending-row' : ''} style={{ animationDelay: `${i * 50}ms` }}>
                    <td>{d.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={d.name} src={imgUrl(d.profileImage)} />
                        <div>
                          <div className="name">{d.name || 'N/A'}</div>
                          {d.isPending && d.submittedByName && <div className="sub">By: {d.submittedByName}</div>}
                        </div>
                      </div>
                    </td>
                    <td>{d.mobileNumber || 'N/A'}</td>
                    <td>{d.licenseNumber || 'N/A'}</td>
                    <td>{d.experience ? `${d.experience} years` : 'N/A'}</td>
                    <td>{d.busOwner?.name || 'N/A'}</td>
                    <td>{d.assignedBus ? <><b>{d.assignedBus.busNumber}</b><br /><small>{d.assignedBus.busName}</small></> : 'Not Assigned'}</td>
                    <td><span className={`prm-status ${d.isPending ? 'pending' : d.isActive ? 'active' : 'inactive'}`}>{d.isPending ? 'Pending' : d.status}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewDriver(d)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => openEdit(d)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                        {d.isPending && (
                          <>
                            <button className="prm-btn primary sm icon-only" onClick={() => handleApprovePendingDriver(d.id)} title="Approve" aria-label="Approve"><Icon name="check" size={14} /></button>
                            <button className="prm-btn danger sm icon-only" onClick={() => handleRejectPendingDriver(d.id)} title="Reject" aria-label="Reject"><Icon name="x" size={14} /></button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION — always visible */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalDrivers}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="drivers"
      />

      {/* EDIT MODAL */}
      {editingDriver && !isFetchingDetails && (
        <div className="prm-overlay" onClick={() => { setEditingDriver(null); setEditForm({}); setIsEditingPending(false); }}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>{isEditingPending ? 'Edit pending driver' : 'Edit driver'}</h3><p>{editForm.mobileNumber || editForm.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => { setEditingDriver(null); setEditForm({}); setIsEditingPending(false); }}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Name" required><input className="prm-input" value={editForm.name || ''} onChange={(e) => setEditForm(p => ({ ...p, name: e.target.value }))} /></Field>
                <Field label="Mobile Number"><input className="prm-input" value={editForm.mobileNumber || ''} onChange={(e) => setEditForm(p => ({ ...p, mobileNumber: e.target.value }))} /></Field>
                <Field label="License Number"><input className="prm-input" value={editForm.licenseNumber || ''} onChange={(e) => setEditForm(p => ({ ...p, licenseNumber: e.target.value }))} /></Field>
                <Field label="Experience (years)"><input type="number" min="0" step="0.5" className="prm-input" value={editForm.experience || ''} onChange={(e) => setEditForm(p => ({ ...p, experience: e.target.value }))} /></Field>
                {!isEditingPending && (
                  <Field label="Status">
                    <label className="dm-toggle">
                      <input type="checkbox" checked={editForm.isActive || false} onChange={(e) => setEditForm(p => ({ ...p, isActive: e.target.checked }))} />
                      <span>{editForm.isActive ? 'Active' : 'Inactive'}</span>
                    </label>
                  </Field>
                )}
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { setEditingDriver(null); setEditForm({}); setIsEditingPending(false); }}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit} disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewingDriver && !isFetchingDetails && (
        <div className="prm-overlay" onClick={() => setViewingDriver(null)}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingDriver.name} src={imgUrl(viewingDriver.profileImage)} size={52} />
                <div>
                  <h3>{viewingDriver.name || 'Driver'}</h3>
                  <p>{viewingDriver.mobileNumber || 'N/A'} · {viewingDriver.email || 'N/A'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingDriver(null)}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b className={viewingDriver.isPending ? 'dm-status-pending' : viewingDriver.isActive ? 'dm-ok' : 'dm-off'}>{viewingDriver.isPending ? 'Pending' : viewingDriver.isActive ? 'Active' : 'Inactive'}</b></div>
                <div><span>Experience</span><b>{viewingDriver.experience} years</b></div>
                <div><span>License</span><b>{viewingDriver.licenseNumber || 'N/A'}</b></div>
                <div><span>Joined</span><b>{viewingDriver.joined}</b></div>
              </div>

              <div className="prm-section-title">Assignment details</div>

              <div className="dm-driver-grid" style={{ marginTop: 8 }}>
                <div>
                  <small>Bus Owner</small>
                  {viewingDriver.busOwner ? (
                    <><b>{viewingDriver.busOwner.name}</b><span>{viewingDriver.busOwner.phone}</span></>
                  ) : <b>N/A</b>}
                </div>
                <div>
                  <small>Assigned Bus</small>
                  {viewingDriver.assignedBus ? (
                    <><b>{viewingDriver.assignedBus.busNumber}</b><span>{viewingDriver.assignedBus.busName}</span></>
                  ) : <b>Not Assigned</b>}
                </div>
                <div>
                  <small>Address</small>
                  <b>{viewingDriver.address || 'N/A'}</b>
                </div>
                <div>
                  <small>Last Updated</small>
                  <b>{viewingDriver.updatedAt}</b>
                </div>
              </div>

              {viewingDriver.isPending && viewingDriver.submittedByName && (
                <div style={{ marginTop: 16, padding: '10px 14px', background: '#fffbeb', borderRadius: 10, border: '1px solid #fde68a', fontSize: 13, color: '#92400e' }}>
                  <Icon name="info" size={14} /> Submitted by: <b>{viewingDriver.submittedByName}</b> · Operation: {viewingDriver.operationType || 'N/A'}
                </div>
              )}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { const d = viewingDriver; setViewingDriver(null); openEdit(d); }}><Icon name="edit" size={15} /> Edit</button>
                <button className="prm-btn primary" onClick={() => setViewingDriver(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* LOADING SKELETON FOR DETAILS */}
      {isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DriverManagement;